module.exports = function _isPlaceholder(a) {
  return a != null &&
         typeof a === 'object' &&
         a['@@functional/placeholder'] === true;
};



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/ramda/src/internal/_isPlaceholder.js
// module id = ../../node_modules/ramda/src/internal/_isPlaceholder.js
// module chunks = 18